import { useEffect, useState } from 'react';
import HeroSection from './components/HeroSection';
import PhilosophySection from './components/PhilosophySection';
import EnsembleSection from './components/EnsembleSection';
import CredentialsSection from './components/CredentialsSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import Navigation from './components/Navigation';
import JsonLd from '../../components/feature/JsonLd';

const siteUrl = import.meta.env.VITE_SITE_URL ?? '';

const enJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      '@id': `${siteUrl}/#organization`,
      name: 'Institute of Japanese Musical Art Expression',
      alternateName: '日本音楽藝術表現研究所',
      url: siteUrl,
      description:
        'A research institute that analyzes and reconstructs the body knowledge of Japanese music, rooted in island sensibilities. Integrating traditional musical currents into contemporary art, entertainment, and education.',
      founder: { '@type': 'Person', name: 'Shogo Yoshii' },
    },
    {
      '@type': 'WebSite',
      '@id': `${siteUrl}/#website`,
      url: siteUrl,
      name: 'Institute of Japanese Musical Art Expression',
      publisher: { '@id': `${siteUrl}/#organization` },
      inLanguage: 'en',
    },
    {
      '@type': 'WebPage',
      '@id': `${siteUrl}/en#webpage`,
      url: `${siteUrl}/en`,
      name: 'Institute of Japanese Musical Art Expression | Japanese Music Research',
      description:
        'A research institute dedicated to analyzing and reconstructing the body knowledge of Japanese traditional music. Bridging tradition and contemporary art, entertainment, and education. Produced by Shogo Yoshii.',
      isPartOf: { '@id': `${siteUrl}/#website` },
      about: { '@id': `${siteUrl}/#organization` },
      inLanguage: 'en',
    },
  ],
};

export default function EnglishPage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="bg-white">
      <title>Institute of Japanese Musical Art Expression | Japanese Music Research</title>
      <meta
        name="description"
        content="A research institute dedicated to analyzing and reconstructing the body knowledge of Japanese traditional music. Bridging tradition and contemporary art, entertainment, and education. Produced by Shogo Yoshii."
      />
      <meta name="keywords" content="Japanese music,music research,traditional music,ensemble,cultural arts,Shogo Yoshii" />
      <link rel="canonical" href={`${siteUrl}/en`} />
      <meta property="og:url" content={`${siteUrl}/en`} />
      <meta property="og:title" content="Institute of Japanese Musical Art Expression | Japanese Music Research" />
      <meta
        property="og:description"
        content="A research institute dedicated to analyzing and reconstructing the body knowledge of Japanese traditional music."
      />
      <JsonLd data={enJsonLd} id="en" />
      <Navigation scrolled={scrolled} />
      <HeroSection />
      <PhilosophySection />
      <EnsembleSection />
      <CredentialsSection />
      <ContactSection />
      <Footer />
    </div>
  );
}
